module.exports = __webpack_public_path__ + "static/media/TechBadge.5d51717f.svg";